import classNames from "classnames";
// constats
import { useTranslation } from "react-i18next";

// types
import { MessageType } from "../../../../pages/payment/paymentPage";
import OutlinedButton from "../../../common/OutlinedButton";
import PrimaryButton from "../../../common/PrimaryButton";
import styles from "../styles.module.scss";
// styles
import resultStyles from "./styles.module.scss";

interface Props {
  messageType: MessageType;
  handleSubmit: () => void;
}

const Result = ({ messageType, handleSubmit }: Props): JSX.Element => {
  const { t } = useTranslation();
  return (
    <div dir="rtl" className={styles.paymentMethodsContainer}>
      <div className={resultStyles.topSection}>
        {messageType === MessageType.SUCCESS && (
          <img alt="img" src="/assets/images/svg/tick.svg" />
        )}
        {messageType === MessageType.ERROR && (
          <img alt="img" src="/assets/images/svg/error.svg" />
        )}
        <div className={resultStyles.topsection_wrapper}>
          {messageType === MessageType.SUCCESS && (
            <h1>{t("lbl_payment_success_title")}</h1>
          )}
          {messageType === MessageType.ERROR && (
            <h1>{t("lbl_payment_rejected_title")}</h1>
          )}
          {messageType === MessageType.SUCCESS && (
            <p className={classNames(styles.p1, styles.g700)}>
              {t("lbl_pay_contract_value_paid")}
            </p>
          )}
          {messageType === MessageType.ERROR && (
            <p className={classNames(styles.p1, styles.g700)}>
              {t("lbl_payment_rejected_sub_title")}
            </p>
          )}
        </div>
      </div>
      {messageType === MessageType.SUCCESS && (
        <div>
          <div className={resultStyles.stepsContainer}>
            <div className={resultStyles.stepImage}>
              <img alt="img" src="/assets/images/svg/step1.svg" />
            </div>
            <div>
              <p className={classNames(resultStyles.p2, resultStyles.g600)}>
                {t("lbl_pay_contract_step_1")}
              </p>
            </div>
          </div>
          <div className={resultStyles.stepsContainer}>
            <div className={resultStyles.stepImage}>
              <img alt="img" src="/assets/images/svg/step2.svg" />
            </div>
            <div>
              <p className={classNames(resultStyles.p2, resultStyles.g600)}>
                {t("lbl_pay_contract_step_2")}
              </p>
            </div>
          </div>
          <div className={resultStyles.stepsContainer}>
            <div className={resultStyles.stepImage}>
              <img alt="img" src="/assets/images/svg/step3.svg" />
            </div>
            <div>
              <p className={classNames(resultStyles.p2, resultStyles.g600)}>
                {t("lbl_pay_contract_step_3")}
              </p>
            </div>
          </div>
        </div>
      )}
      {messageType === MessageType.SUCCESS && (
        <OutlinedButton onClick={handleSubmit}>
          {t("lbl_close_button")}
        </OutlinedButton>
      )}
      {messageType === MessageType.ERROR && (
        <PrimaryButton onClick={handleSubmit}>
          {t("lbl_try_again")}
        </PrimaryButton>
      )}
    </div>
  );
};

export default Result;
